import React, { FC } from "react";
import { ReportPage, ReportTreasurySearchPanel } from "../../../components";
import { PageEnum, TreasuryReportSearchParamsModel } from "../../../models";
import { getPageNameByPageId, getSystemLanguageId } from "../../../utils";
import { searchReportAllInAndOutMoney } from "../../../serviceBroker/treasuryReportApiServiceBroker";
import { subDays } from "date-fns";

export const ReportAllInAndOutMoneyPage: FC = () => {
  const today = new Date();
  const sevenDaysAgo = subDays(today, 7);

  const initialState: TreasuryReportSearchParamsModel = {
    Lang: getSystemLanguageId(),
    toDate: new Date(),
    fromDate: sevenDaysAgo,
  };
  return (
    <ReportPage
      InitialState={initialState}
      excludeFields={["currencyId", "employeeId", "accountId"]}
      SearchApi={searchReportAllInAndOutMoney}
      searchHeader={getPageNameByPageId(PageEnum.ReportAllInAndOutDayMoney)}
      SearchPanel={ReportTreasurySearchPanel}
      formId={PageEnum.ReportAllInAndOutDayMoney}
    />
  );
};
